var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.035 13.25a.25.25 0 0 0-.177.427l4.157 4.157a.75.75 0 0 1 0 1.06l-.707.707a.75.75 0 0 1-1.06 0l-7.071-7.07a.75.75 0 0 1 0-1.061l7.07-7.071a.75.75 0 0 1 1.061 0l.707.707a.75.75 0 0 1 0 1.06l-4.157 4.157a.25.25 0 0 0 .177.427H19.5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75z"
  })));
};
export default SvgArrowLeft;